export const add_or_update_user = (username, userData) => {
    return {
        type : "ADD_OR_UPDATE_USER",
        username : username,
        payload : userData
    }
}